import { CloseOutlined } from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Dialog, IconButton, Paper, TextField, Typography } from '@mui/material';
import AppButton from '../../../../components/ui/AppButton';

const TransferUserCompanyDialog = ({ open, onClose, onConfirm, value, onChange, companyCode }) => {
  return (
    <Dialog open={open} disableEscapeKeyDown onClose={onClose}>
      <Paper
        sx={{ minWidth: '500px', backgroundColor: 'white', padding: '2rem', position: 'relative' }}
      >
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', top: '5px', right: '5px', borderRadius: '8px' }}
        >
          <CloseOutlined />
        </IconButton>
        <Typography
          sx={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#002B38',
            marginBottom: '10px',
            textAlign: 'center',
          }}
        >
          ต้องการย้ายบริษัท
        </Typography>
        <Box
          component="label"
          htmlFor="transferUser"
          sx={{ fontSize: '1.5rem', marginBottom: '5px' }}
        >
          รหัสบริษัทปลายทาง
        </Box>
        <TextField
          id="transferUser"
          size="small"
          placeholder="e.g. xxxxx"
          hiddenLabel
          fullWidth
          value={value}
          onChange={(e) => onChange(e.target.value || '')}
          sx={{
            '& .MuiInputBase-root': {
              fontSize: '1.5rem',
            },

            '& .MuiInputBase-input::placeholder': {
              fontSize: '1.5rem',
            },
          }}
        />
        {companyCode === value && (
          <Box
            sx={{
              padding: '5px 10px',
              margin: '10px 0',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              fontSize: '1.125rem',
              color: '#ef4444',
              backgroundColor: '#fca5a5',
              borderRadius: '4px',
            }}
          >
            <ErrorIcon sx={{ fontSize: '1.125rem' }} />
            บริษัทปลายทางตรงกับบริษัทที่อยู่เดิม
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
            marginTop: '20px',
          }}
        >
          <AppButton
            variant="text"
            onClick={onConfirm}
            disabled={companyCode === value}
            sx={{
              width: '100px',
              fontSize: '1.25rem',
              fontWeight: 'bold',
              borderRadius: '8px',
              color: 'white',
              backgroundColor: '#FD0004',
              border: '2px solid #FD0004',
              boxShadow: 'none',

              '&:hover': {
                color: '#FD0004',
                backgroundColor: 'white',
                border: '2px solid #FD0004',
                boxShadow: 'none',
              },
              '&.Mui-disabled': {
                color: 'white',
                backgroundColor: '#aaa',
                borderColor: '#aaa',
              },
            }}
          >
            ตกลง
          </AppButton>
          <AppButton
            variant="text"
            onClick={onClose}
            sx={{
              width: '100px',
              fontSize: '1.25rem',
              fontWeight: 'bold',
              borderRadius: '8px',
              color: '#004B61',
              backgroundColor: 'white',
              border: '2px solid #004B61',
              boxShadow: 'none',

              '&:hover': {
                color: '#004B61',
                backgroundColor: 'white',
                border: '2px solid #004B61',
                opacity: '.85',
                boxShadow: 'none',
              },
            }}
          >
            ยกเลิก
          </AppButton>
        </Box>
      </Paper>
    </Dialog>
  );
};
export default TransferUserCompanyDialog;
